/**
 * Utility functions for audit-related API operations
 */
/**
 * Create or update an audit
 * @param {Object} context - Vue component instance (this)
 * @param {Object} audit - The audit data
 * @param {boolean} newEntry - Whether this is a new entry
 * @returns {Promise} - API response promise
 */
export function saveAudit(context, audit, newEntry) {
    const endpoint = newEntry ? 'audit/create' : 'audit/update';
    return context.$postData(endpoint, audit);
}

/**
 * Delete an audit
 * @param {Object} context - Vue component instance (this)
 * @param {Object} audit - The audit to delete
 * @returns {Promise} - API response promise
 */
export function deleteAudit(context, audit) {
    return context.$postData('audit/delete', { id: audit.id });
}
